import config from 'config'
import { Redirect } from 'react-router-dom'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'
import { LEVELS } from 'constants/enums'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/participants`,
    exact: true,
    component: () => (
      <Redirect to={`${publicPath}/participants/my-participants`} />
    )
  },
  {
    path: `${publicPath}/participants/my-participants`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.Participants
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }>
          <Page.ParticipantsMyGrid {...props} params={get(props, 'match.params', {})} />
        </Page.Participants>
      </Main>
    )
  },
  {
    path: `${publicPath}/participants/all-participants`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.Participants
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }>
          <Page.ParticipantsAllGrid {...props} params={get(props, 'match.params', {})} />
        </Page.Participants>
      </Main>
    )
  },
  {
    path: `${publicPath}/participants/:id`,
    exact: true,
    component: props => (
      <Redirect to={`${publicPath}/participants/${props.match.params.id}/detail`} />
    )
  },
  {
    path: `${publicPath}/participants/:id`,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
       <Page.Participants
          {...props}
          params={get(props, 'match.params', {})}>
          <Page.Participant
            {...props}
            params={get(props, 'match.params', {})}
            tabs={
              <Tabs {...props} params={get(props, 'match.params', {})} />
            }
          />
        </Page.Participants>
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/participants/:id/detail`,
        exact: true,
        component: props => (
          <Page.ParticipantsDetail {...props} params={get(props, 'match.params', {})} />
        )
      },

      {
        path: `${publicPath}/participants/:id/bronze-level`,
        exact: true,
        awardLevelId: LEVELS.BRONZE.value,
        component: props => (
          <Page.ParticipantBronzeLevel {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/participants/:id/bronze-level/:subTabId`,
        exact: true,
        awardLevelId: LEVELS.BRONZE.value,
        component: props => (
          <Page.ParticipantBronzeLevel {...props} params={get(props, 'match.params', {})} />
        )
      },

      {
        path: `${publicPath}/participants/:id/silver-level`,
        exact: true,
        awardLevelId: LEVELS.SILVER.value,
        component: props => (
          <Page.ParticipantSilverLevel {...props} />
        )
      },
      {
        path: `${publicPath}/participants/:id/silver-level/:subTabId`,
        exact: true,
        awardLevelId: LEVELS.SILVER.value,
        component: props => (
          <Page.ParticipantSilverLevel {...props} />
        )
      },

      {
        path: `${publicPath}/participants/:id/gold-level`,
        exact: true,
        awardLevelId: LEVELS.GOLD.value,
        component: props => (
          <Page.ParticipantGoldLevel {...props} />
        )
      },
      {
        path: `${publicPath}/participants/:id/gold-level/:subTabId`,
        exact: true,
        awardLevelId: LEVELS.GOLD.value,
        component: props => (
          <Page.ParticipantGoldLevel {...props} />
        )
      },

      {
        path: `${publicPath}/participants/:id/history`,
        exact: true,
        component: props => (
          <Page.ParticipantHistory {...props} />
        )
      },
      {
        path: `${publicPath}/participants/:id/award`,
        exact: true,
        component: props => (
          <Page.ParticipantAwardSinglePage {...props} />
        )
      }
    ]
  }

]

export default routes
